import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import { useStateValue } from 'providers'
import { Card, Title } from 'components'
import { getUserName } from 'utils'
import { ChatPanel } from '../games/chat/components/panel'
import { RequireUsername } from '../games/chat/components/require-username'
import { useDirectMessageChat } from './use-direct-message-chat'

const Page = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`

export const MessageThread = () => {
  const [
    {
      session: { user }
    }
  ] = useStateValue()
  const { username } = useParams()
  const { comments, send, otherUser } = useDirectMessageChat(username)

  return (
    <Page>
      <Title level={2} color="link">
        {otherUser ? getUserName(otherUser) : username}
      </Title>
      <RequireUsername user={user}>
        <ChatPanel comments={comments} currentUserId={user.id} onSend={send} />
      </RequireUsername>
    </Page>
  )
}
